import { Flex } from 'antd';
import { Skeleton } from '@common-web';

const CategoryLoader = () => (
  <Flex vertical>
    {[1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => {
      return (
        <div style={{ padding: '17px 24px' }} key={index}>
          <Skeleton containerClassName="flex" height={12} width={130} />
        </div>
      );
    })}
  </Flex>
);

export default CategoryLoader;
